export default __webpack_public_path__ + "static/media/SonaLogo.8cfe4b9e.png";